export function marketInputGuidance({
  suggestedValue,
  adoptedValue,
  postcodeArea,
  showValidationErrors,
}) {
  if (suggestedValue) return {}

  const area = postcodeArea ? `${postcodeArea} market` : 'local market'

  if (adoptedValue) {
    return { helperText: `No ${area} data available. Review this adopted value before calculating.` }
  }

  if (showValidationErrors) {
    return { error: 'Enter an adopted value before calculating.' }
  }

  return { helperText: `No ${area} data available. Enter an adopted value manually.` }
}
